import * as types from './mutation-types.js'
import api from '../api'
import { getField, updateField } from 'vuex-map-fields'

const downloadExcel = (name, payload) => {
	const blob = new Blob([payload], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
	const url = window.URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url
	link.download = name
	document.body.appendChild(link)
	link.click()
	link.parentNode.removeChild(link)
	window.URL.revokeObjectURL(url)
}

const orderStatuses = {
	delivery: 'Orders are ready For Delivery.',
	complete: 'Orders are Received.',
	cancelled: 'Orders are Cancelled.'
}

const state = {
	orderList: {
		data: [],
		total: 0,
		per_page: 10
	},
	orderListLoading: false,

	orderView: {},
	orderViewLoading: false,

	buttonLoading: false,

	selected: [],
	lastQueryParams: ''
}

const mutations = {
	updateField,

	[types.GET_ORDERS] (state) {
		state.orderListLoading = true
	},

	[types.GET_ORDERS_SUCCESS] (state, payload) {
		state.orderList = payload
		state.orderListLoading = false
	},

	[types.GET_ORDERS_FAIL] (state, payload) {
		state.orderListLoading = false
	},

	[types.GET_ORDER_VIEW] (state) {
		state.orderViewLoading = true
	},

	[types.GET_ORDER_VIEW_SUCCESS] (state, payload) {
		state.orderView = payload
		state.orderViewLoading = false
	},

	[types.GET_ORDER_VIEW_FAIL] (state) {
		state.orderViewLoading = false
	}
}

const actions = {

	async getOrderList ({ commit }, payload) {
		commit(types.GET_ORDERS)

		const { data, status } = await api('get', `/order/list${payload}`)

		if (status) {
			commit(types.GET_ORDERS_SUCCESS, data.data)
			return
		}

		commit(types.GET_ORDERS_FAIL, data)
	},

	async viewOrder ({ commit }, payload) {
		commit(types.GET_ORDER_VIEW)
		const { data, status } = await api('get', `/order/view?transaction_id=${payload}`)
		if (status) {
			commit(types.GET_ORDER_VIEW_SUCCESS, data.data)
			return
		}

		commit(types.GET_ORDER_VIEW_FAIL)
	},

	async actions ({ state, dispatch }, payload) {
		state.buttonLoading = true

		const { data, status } = await api('post', '/order/update-status', payload.form)

		if (status) {
			state.orderList = data.data
			state.selected = []
			payload.store.dispatch('toggleBanner', {
				status: true,
				message: orderStatuses[payload.status],
				type: 'success'
			})
			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async downloadExcel ({ state, commit }, payload) {
		state.buttonLoading = true

		const { data } = await api('post', '/order/export-per-order', payload.form, true)

		downloadExcel(`${payload.name}'s Order.xlsx`, data)
		state.buttonLoading = false
	},

	clearData ({ state }) {
		state.orderList = {
			data: [],
			total: 0,
			per_page: 10
		}

		state.orderListLoading = false
		state.buttonLoading = false
		state.selected = []
	}
}

const getters = {
	getField,

	getOrderList: state => state.orderList,
	getOrderListLoading: state => state.orderListLoading

}

export default {
	state,
	namespaced: true,
	mutations,
	actions,
	getters
}
